import { DatabaseFilled } from "@ant-design/icons";
import { Col, Divider, Row, Typography, Image } from "antd";
import React from "react";
import StandartTable from "../../../../components/Elements/StandartTable";
import { useCollection } from "../../../../hooks/useCollection";
import moment from "moment";

const { Title, Text } = Typography;

const defaultColumns = [
   {
      title: "Comment",
      dataIndex: "comment",
      align: "center",
   },
   {
      title: "Photo",
      dataIndex: ["imageUrl"],
      align: "center",
      render: (value) => (
         <>
            <Image width={50} src={value} />
         </>
      ),
   },
   {
      title: "Recieved",
      dataIndex: ["dateAdded"],
      align: "center",
      sorter: (a, b) => a.date.create.seconds - b.date.create.seconds,
      render: (value) => (
         <>
            <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
         </>
      ),
   },
];

export default function OrderMatching() {
   const { data, loading } = useCollection("accountantInvoices");

   return (
      <div style={{ padding: 15 }}>
         <Row gutter={[15, 15]}>
            <Col span={24}>
               <Title level={3}>
                  <DatabaseFilled />
                  <Divider type="vertical" />
                  Order Matching
               </Title>
            </Col>
            <Col span={24}>
               <StandartTable data={data} columns={defaultColumns} loading={loading} />
            </Col>
         </Row>
      </div>
   );
}
